/** @format */

import { BundleData } from './bundle-data.interface';
import { QueryParam } from './query-param.interface';
import { ProductSku } from './product-sku.interface';
import { ProductsData } from './product/products-data.interface';

export interface ProcessedBundleProduct extends BundleData {
  actualAdditionalQueryParams?: QueryParam[];
  colorQueryParam?: string;
  defaultColor: string;
  ecodes: ProductsData[];
  isBundle?: true;
  skuIdList?: string[];
  skuIdQueryParam?: string;
  // always empty
  skus?: ProductSku[];
}
